import fuse from '../../../_libs/redux-fusion';
import {CreateCardContainerHOC} from '../../../components/lists/CreateCard';
import {createOrgRequest} from '../../redux/createOrg';
import {CreateOrgCardComponent} from './CreateOrgCardComponent';


const StreamedComponent = CreateCardContainerHOC({reduxRequest: createOrgRequest});

export const CreateOrgCardContainer = fuse(StreamedComponent)(CreateOrgCardComponent);



// WEBPACK FOOTER //
// ./src/js/organizations/components/CreateOrgCard/CreateOrgCardContainer.js